import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

export const SelectorOptions = ({ options, translateOptions }) => {
  const intl = useIntl();

  const finalOptions = options.map((option) => {
    if (translateOptions) {
      return {
        ...option,
        name: intl.formatMessage({ id: option.name }),
      };
    }

    return option;
  });

  return finalOptions.map((option) => (
    <option key={option.id} value={option.value !== undefined ? option.value : option.id}>
      {option.name}
    </option>
  ));
};

SelectorOptions.propTypes = {
  options: PropTypes.array,
  translateOptions: PropTypes.bool,
};
